import React from 'react';
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import 'react-alice-carousel/lib/alice-carousel.css'; // requires a loader
import AliceCarousel from 'react-alice-carousel';
import { useSelector } from 'react-redux';
const Carousels = () => {
	const { hotel } = useSelector((state) => state.home);
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const responsive = {
		0: { items: 1 },
		568: { items: 2 },
		1024: { items: 4 },
	};
	const items = hotel?.result.map((i, index) => {
		return (
			<div className='item' data-value='1' style={{ marginTop: 20 }}>
				<Box style={{ width: matches ? '100%' : '90%' }}>
					<Box>
						<img
							// src={i.image}
							src={
								'https://assets-news.housing.com/news/wp-content/uploads/2022/06/28100601/15-worlds-best-places-to-visit-13.jpg'
							}
							style={{
								width: '100%',
								height: 280,
								borderRadius: 5,
							}}
						/>
					</Box>
				</Box>
			</div>
		);
	});
	const demo = [
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 10 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 20 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 30 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 40 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 50 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 60 }}
		/>,
	];
	const item = [0, 1, 2];
	return (
		<AliceCarousel
			autoPlay
			infinite
			mouseTracking
			items={hotel?.result.length > 0 ? items : demo}
			autoPlayInterval={3000}
			responsive={responsive}
			controlsStrategy='alternate'
			keyboardNavigation={true}
			renderPrevButton={() => {
				return <p></p>;
			}}
			renderNextButton={() => {
				return <p></p>;
			}}
		/>
	);
};

export default Carousels;
